var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.205 3.205v25.59h25.59V3.205H3.205zm24.524 1.066v4.798H4.272V4.271h23.457zM4.271 27.729V10.136h23.457v17.593H4.271z",
    fill: "#0B0C0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.201 5.871h1.6V7.47h-1.6V5.871zM19.199 5.871h1.599V7.47h-1.599V5.871zM12.348 13.929c-.191 1.297-.808 1.32-2.05 1.365l-.193.007v.904h2.104v5.914h1.116v-8.361h-.953l-.025.171zM18.642 16.442a2.58 2.58 0 0 0-1.408.433l.38-1.955h3.515v-1.06h-4.347l-.848 4.528h.965l.059-.092c.337-.525.952-.852 1.606-.852 1.064 0 1.836.787 1.836 1.87 0 .98-.615 1.972-1.79 1.972-1.004 0-1.726-.678-1.756-1.649l-.006-.194h-1.115l.005.205c.036 1.58 1.167 2.641 2.816 2.641 1.662 0 2.963-1.272 2.963-2.895 0-1.766-1.154-2.953-2.872-2.953z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.36e60b565d9cd2f5dffae34799e4d74f.svg";
export { ForwardRef as ReactComponent };